import { BusinessRole, EndMarketRole } from "fe-shared/src/types/domain";

export const isEndMarketRole = (businessRoleCode: BusinessRole) =>
  Object.values(EndMarketRole).includes(
    (businessRoleCode as unknown) as EndMarketRole
  );

export default isEndMarketRole;
